<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">
      <b>姓名：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.project"
                placeholder="请输入姓名"/>
      <el-button type="primary" @click="getList" round>查询</el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>
      <el-button type="primary" @click="handleEdit({id:0})" round>新增用户</el-button>
    </div>

    <el-table
        :data="tableData"
        style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column
          label="姓名"
          align="center"
          prop="nickname">
      </el-table-column>
      <el-table-column
          align="center"
          label="系统账号"
          prop="username">
      </el-table-column>
      <el-table-column
          align="center"
          label="所属部门/单位"
          :formatter="formatDept"
          prop="dept">
      </el-table-column>
      <el-table-column
          align="center"
          label="最近登录ip"
          prop="loginIp">
      </el-table-column>
      <el-table-column
          align="center"
          label="角色" :formatter="formatrole"
          prop="role1">
      </el-table-column>
      <el-table-column
          align="center"
          width="300"
          label="操作">
        <template slot-scope="scope">
          <el-button
              size="mini"
              @click="handleEdit(scope.row)">修改
          </el-button>
          <el-button
              size="mini"
              @click="roleEdit(scope.row)">授权
          </el-button>
          <el-button
              size="mini"
              @click="qweEdit(scope.row)">重置
          </el-button>
          <el-button
              size="mini"
              v-if="scope.row.status===1"
              type="danger"
              @click="stopUser(scope.row)">禁用
          </el-button>
          <el-button
              size="mini"
              v-if="scope.row.status===0"
              type="success"
              @click="startUser(scope.row)">启用
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <template>
      <div>

        <pagination
            id="roleListpage"
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>

    <el-dialog title="修改用户信息" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="form" :rules="formRules" id="scfrom"  label-width="130px">
        <el-form-item label="姓名" prop="nickname">
          <el-input v-model="form.nickname" :disabled="form.id > 0"></el-input>
        </el-form-item>

        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username" :disabled="form.id > 0"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password" v-show="form.id > 0">
          <el-input v-model="form.password" type="password"></el-input>
        </el-form-item>

        <el-form-item label="角色" prop="role1">
          <el-select v-model="form.role1" placeholder="请选择" style="width: 100%;">
            <el-option
                v-for="item in roleoptions"
                :key="item.id"
                :label="item.rolename"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="性别" prop="sex">
          <el-select v-model="form.sex" placeholder="请选择" style="width: 100%;">
            <el-option
                v-for="item in optionssex"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>

        <el-form-item label="所属部门或单位" prop="dept">
          <el-select v-model="form.dept" placeholder="请选择" style="width: 100%;">
            <el-option
                v-for="item in deptoptions"
                :key="item.id"
                :label="item.deptName"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="SubmitSc">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="用户授权" :visible.sync="roledialogFormVisible">
      <el-form :model="selectTable">
        <el-form-item label="用户名:" label-width="100px">
          <p style="margin: 0px">{{ selectTable.username }}</p>
        </el-form-item>
      </el-form>


      <el-tree
          class="tree-border"
          :data="selectTable.menuOptions"
          show-checkbox
          :default-checked-keys="selectTable.defalutCheckArr"
          ref="menu"
          node-key="pid"
          :check-strictly=false
          empty-text="加载中，请稍候"
          :props="defaultProps"
      ></el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roledialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saverole">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    // 自定义手机号校验
    const validatePhone = (rule, value, callback) => {
      if ( value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };

    // 自定义邮箱校验
    const validateEmail = (rule, value, callback) => {
      if ( value && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
        callback(new Error('请输入正确的邮箱地址'));
      } else {
        callback();
      }
    };

    // 自定义密码校验（编辑时使用）
    const validatePassword = (rule, value, callback) => {
      if (this.form.id > 0 && !value) {
        callback(new Error('密码不能为空'));
      } else if (value && value.length < 6) {
        callback(new Error('密码长度不能少于6位'));
      } else {
        callback();
      }
    };
    return {
      formRules: {
        nickname: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]+$/, message: '账号只能包含字母、数字和下划线', trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        role1: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        dept: [
          { required: true, message: '请选择所属部门或单位', trigger: 'change' }
        ]},
      selectTable: {
        role: '',
        rolename: '',
        menuOptions: [],
        defalutCheckArr: [],
        rptid: 0
      },
      form: {
        id: '',
        user: '',
        username: '',
        password: '',
        sex: '',
        dept: '',
        email: '',
        phone: '',
      },
      total: 0,
      optionssex: [],
      roleoptions: [],
      deptoptions: [],
      queryParams: {
        project: '',
        pageNum: 1,
        pageSize: 10,
      },
      defaultProps: {
        children: "children",
        label: "pname"
      },
      dialogFormVisible: false,
      roledialogFormVisible: false,
      dialogFormData: [],
      tableData: null,
      tablelistData: [],
      search: ''
    }
  },
  mounted() {
    this.getList();
    this.getDic("sex")
    this.getdept("")
    this.getroleList();
  },
  methods: {
    formatDept(row, column, cellValue) {
      // 从 optionskhlx 中查找对应的 label
      const option = this.deptoptions.find(item => item.id === cellValue);
      return option ? option.deptName : cellValue;
    },
    formatrole(row, column, cellValue) {
      // 从 optionskhlx 中查找对应的 label
      const option = this.roleoptions.find(item => item.id === cellValue);
      return option ? option.rolename : cellValue;
    },
    getroleList() {
      this.$request.postHttp({
        url: "/system/getroleDic",
        success: (data) => {
          this.roleoptions = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })

    },

    saverole() {
      this.selectTable.defalutCheckArr = this.$refs.menu.getCheckedKeys()
      this.$request.postHttp({
        url: "/system/updateroleByuser",
        data: JSON.stringify(this.selectTable),
        success: (data) => {
          this.$message.success(data.msg)
          this.roledialogFormVisible = false
          this.getList();
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getDic(val) {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: val},
        success: (data) => {
          this.optionssex = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getdept(val) {
      this.$request.postHttp({
        url: "/system/getdept",
        params: {pname: val},
        success: (data) => {
          this.deptoptions = data.data

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    handleEdit(row) {
      if (row.status === 0) {
        this.$message.warning('当前用户为停用状态不可修改')
        return
      }
      this.$request.postHttp({
        url: "/system/getuser",
        params: {id: row.id},
        success: (data) => {
          this.dialogFormVisible = true;
          this.form = data.data
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.clearValidate();  // 清空所有验证提示
            }
          });
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })

    },
    roleEdit(row) {
      if (row.status === 0) {
        this.$message.warning('当前用户为停用状态不可授权')
        return
      }
      this.selectTable.id = row.id
      this.selectTable.username = row.username
      this.$request.getHttp({
        url: "/system/getuserrole",
        params: {uid: this.selectTable.id},
        success: (data) => {
          this.selectTable.defalutCheckArr = data.data.checkData
          this.selectTable.rptid = data.data.pid
          console.log(1)
          this.selectTable.menuOptions = this.listToTree(data.data.treeData[0])
          this.roledialogFormVisible = true;
        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })

    },
    qweEdit(row) {
      if (row.status === 0) {
        this.$message.warning('当前用户为停用状态不可重置密码')
        return
      }
      let user = {id: row.id, password: '123456', istop: 1}
      this.$request.postHttp({
        url: "/api/auth/upqwe",
        data: JSON.stringify(user),
        success: (data) => {
          this.$message.success('重置成功，初始密码为123456');
        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })

    },
    stopUser(row) {
      this.$request.postHttp({
        url: "/system/saveUserInfo",
        data: JSON.stringify({id: row.id, status: 0}),
        success: (data) => {
          if (data.code == 200) {
            this.$message.success('用户已禁用');
            this.getList()
          } else {
            this.$message.warning(data.msg);
          }

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },

    startUser(row) {
      this.$request.postHttp({
        url: "/system/saveUserInfo",
        data: JSON.stringify({id: row.id, status: 1}),
        success: (data) => {
          if (data.code == 200) {
            this.$message.success('用户已启用');
            this.getList()
          } else {
            this.$message.warning(data.msg);
          }

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },

    listToTree(list) {
      let map = {}, node, tree = [], i;
      for (i = 0; i < list.length; i++) {
        map[list[i].pid] = i; // 初始化映射
        list[i].children = []; // 初始化children
      }
      for (i = 0; i < list.length; i++) {
        node = list[i];
        if (node.parentid != '0') {
          // 找到当前项的父项的索引
          let parent = list[map[node.parentid]];
          // 将当前项添加到父项的children数组中
          parent.children.push(node);
        } else {
          tree.push(node); // 添加到树结构中
        }
      }
      return tree;
    },
    handleDelete(index, row) {
      console.log(index, row);
      this.tableData.splice(index, 1);

    },
    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/system/userlist",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    SubmitSc() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$request.postHttp({
            url: "/system/saveUserInfo",
            data: JSON.stringify(this.form),
            success: (data) => {
              if (data.code == 200) {
                this.$message.success(data.data.msg);
                this.dialogFormVisible = false
                this.getList()
              } else {
                this.$message.warning(data.msg);
              }

            },
            error: (error) => {
              console.error("Error:", error);
              // 执行失败时的操作
            },
          })
        } else {
          // 校验失败
          this.$message.error('请完善表单信息');
          return false;
        }
      });

    },
  },

}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

selectupwidth el-select {
  width: 120px;
}
</style>